import { NgModule } from '@angular/core';
// import { ArticleComponent } from './shared/article/article.component';
// import { UpdateArticleComponent } from './shared/edit-article/update-article.component';
import { MediathequeComponent } from './mediatheque/mediatheque.component';
import { NbToggleModule, NbCardModule, NbDialogModule, NbButtonModule, NbSpinnerModule, NbToastrModule, NbCheckboxModule, NbDialogRef, NbIconModule, NbActionsModule, NbAlertModule, NbUserModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ApiService } from './api.service';
import {NgbModule, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
// import { CKEditorModule } from 'ng2-ckeditor';
import { EventSendeurService } from './event-sendeur.service';
import { RouterModule, Routes } from '@angular/router';
 import { CKEditorModule } from 'ngx-ckeditor';
import { DatePipe, CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HorsideRoutingModule } from '../horside-routing.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { AuthModule } from '../auth/auth.module';
import { AuthGuard } from '../auth/auth-guard.service';
import { AuthService } from '../auth/auth.service';
import { AutoLogoutService } from '../auth/auto-logout/auto-logout.service';
import { PaysService } from './pays.service';

const maRoutes: Routes = [

  

    /* {
      path: 'log',
      component: DeleteArticleComponent,canActivate: [AuthGuard],
      
    }, */
  ]

@NgModule({
  imports: [
    AuthModule, NbToggleModule, NbCardModule,NgMultiSelectDropDownModule.forRoot(),NbIconModule , NbAlertModule, NbEvaIconsModule,HorsideRoutingModule,RouterModule.forChild(maRoutes),CKEditorModule,CommonModule, BrowserModule,NbCheckboxModule, Ng2SmartTableModule,RouterModule, CKEditorModule, NgbModule ,HttpClientModule,FormsModule, NbToastrModule.forRoot(), NbSpinnerModule,NbButtonModule,NbDialogModule.forChild(), NbActionsModule, NbUserModule,
  ],
  declarations: [ 
    MediathequeComponent, LoginComponent, 
  ],
  providers:[PaysService, ApiService,EventSendeurService,DatePipe,AuthGuard, AuthService, AutoLogoutService, NgbActiveModal,{
    provide: NbDialogRef 
   
  }],
  entryComponents:[],
  exports: [
    AuthModule, NbIconModule, NbActionsModule, NbUserModule, NbAlertModule, NbEvaIconsModule, HorsideRoutingModule,CommonModule, RouterModule, BrowserModule,NbCheckboxModule,CKEditorModule,RouterModule,CKEditorModule,NbSpinnerModule,NgbModule, HttpClientModule,FormsModule,NbButtonModule,NbCardModule,Ng2SmartTableModule, MediathequeComponent, LoginComponent, 
    NbDialogModule,  MediathequeComponent, LoginComponent
  ]
})
export class ShareModule {}